import { format } from 'url';

import PropTypes from 'prop-types';
import React, { Component, Fragment } from 'react';
import isEqual from 'lodash/isEqual';
import _difference from 'lodash/difference';
import omit from 'lodash/omit';
import { injectIntl, FormattedMessage } from 'react-intl-next';
import { styled } from '@compiled/react';
// We have deprecated unstated. Please use react-sweet-state instead
// eslint-disable-next-line no-restricted-imports
import { Subscribe } from 'unstated';

import { token } from '@atlaskit/tokens';
import { withAnalyticsEvents } from '@atlaskit/analytics-next';
import SectionMessage from '@atlaskit/section-message/section-message';
import CommentIcon from '@atlaskit/icon/glyph/comment';
import DropdownMenu, { DropdownItem, DropdownItemGroup } from '@atlaskit/dropdown-menu';
import { Box, Inline } from '@atlaskit/primitives';
import FeatureGates from '@atlaskit/feature-gate-js-client';

import {
	ADD_PAGE_COMMENT_EXPERIENCE,
	VIEW_PAGE_COMMENTS_EXPERIENCE,
	ExperienceSuccess,
	ExperienceAbort,
	ExperienceTimeout,
	withExperienceTracker,
} from '@confluence/experience-tracker';
import { PageSegmentLoadEnd, PageSegmentLoadMark } from '@confluence/browser-metrics';
import { PAGE_COMMENTS_METRIC } from '@confluence/comments-section/entry-points/pageSegmentLoadMetrics';
import { isEmptyAdf } from '@confluence/comments-util';
import { DocumentScroller } from '@confluence/scroll';
import { getLogger } from '@confluence/logger';
import { GeneralShortcutListener, CREATE_COMMENT_SHORTCUT } from '@confluence/shortcuts';
import { FlagsStateContainer } from '@confluence/flags';
import { withSearchSession } from '@confluence/search-session';
import { withSessionData } from '@confluence/session-data';
import {
	CommentsSummarySource,
	FooterCommentsSummaryButton,
	FooterCommentsSummaryCombined,
	SUMMARY_AUTOGENERATE_LIMIT,
} from '@confluence/ai-comments-summary';
import { END } from '@confluence/navdex';

import { CommentsListBatch } from '../CommentsList';
import { Comment } from '../Comment';
import { confirm } from '../../tech-debt/facades/window';
import { getElementById } from '../../tech-debt/facades/document';
import { rebindUserHover } from '../../tech-debt/facades/confluence';
import { EDITOR_VERSIONS } from '../../constants/editor-constants';

import { processAndFetchErrorDetails } from './helpers/errorHandling';
import { EDITOR_MODE, ERROR_TYPES, NEW_COMMENT_ID } from './helpers/constants';
import { i18n } from './i18n';
import { CommentErrorFlag } from './CommentErrorFlag';

const NO_EDITOR_ERROR_STATE = {
	formattedErrorMessage: {},
	errorType: null,
	errorDetails: '',
};

const BATCH_SIZE = 10;

const logger = getLogger('comments-section');

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const CommentsSectionContainer = styled.div({
	listStyle: 'none',
	paddingTop: token('space.250', '20px'),
	width: '100%',
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const CommentHeadline = styled.div({
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
	'h2 span': {
		paddingLeft: token('space.100', '8px'),
	},

	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
	h2: {
		display: 'flex',
		alignItems: 'center',
		fontWeight: 600,
		fontSize: 14,
	},

	display: 'flex',
	justifyContent: 'space-between',
});

const SUMMARY_VISIBILITY_THRESHOLD = 5;

export const CommentsSectionFabricComponent = withSearchSession(
	withSessionData(
		withExperienceTracker(
			/**
			 * Atlassian Account ID
			 */
			/**
			 * React-intl methods
			 */
			/**
			 * Function for replacing routes in the window history.
			 */
			/**
			 * The location from react-router
			 */
			/**
			 * Current ViewPage ID
			 */
			/**
			 * Total number of comments
			 */
			/**
			 * Has all the page comments been successfully fetched
			 */
			/**
			 * Is already requesting for comments
			 */
			/**
			 * Array of comments
			 */

			/**
			 * Id of the comment that should be in focus
			 */
			/**
			 * defines can we scroll to the comment or not
			 */
			/**
			 * Id of the comment that user replaying to (based on url param)
			 */
			/**
			 * Content Type of the page
			 */
			/**
			 * Atlassian token
			 */
			/**
			 * Current user info
			 */
			/**
			 * Mutation to delete a comment for a contentId
			 */
			/**
			 * Mutation to add comment to page
			 */
			/**
			 * Indicates should we automatically open add comment editor and scroll to it
			 */
			/**
			 * The Id of a comment that specified in URL and should be edited
			 */
			/**
			 * Is currently specified comment in a URL found among the list of comments
			 */
			/**
			 * Indicates should render add comment form or not
			 */
			/**
			 * Callback to refetch the list of comment
			 */
			/**
			 * The list of Comment Ids
			 */
			/**
			 * If there is more comment to page through
			 */
			/**
			 * Indicate loading state of comments section
			 */
			/**
			 * Error while attempting to delete comment
			 */
			/**
			 * The list of Comment Ids that have been edited
			 */
			/**
			 * for firing analytics events to be consumed by the provider
			 */

			/**
			 *  We need to wait till incremental loading finishes (fetchMore return empty result)
			 *  to update the updatedCommentsIds. Otherwise all incremental loaded comment will
			 *  be highlighted with newly incremental loaded comments
			 */
			/* eslint react/no-unused-state:0 */
			//only call editCommentAction to open the Editor if User has access to edit

			// scroll to focused comment

			// scroll to comment area
			// Handle Confluence User Hovers in native Confluence way for comments mentions
			/* compoundExperience */
			/* editorLoadExperience */
			/* editorPublishExperience */
			//For top-level Comments we don't have a commentId, setting commentId: "newComment"

			/** in case the processAndFetchErrorDetails throws an exception we set errorType and formattedErrorMessage
     to the default values **/

			// TODO Consider defining a new @confluence/experience-tracker experience
			// add-page-fabric-comment/cancelled-by-user.

			//show Message when user has queryparam in URL to reply or add comment but does not have permission

			//Render null if User does not have permission to add comments and no editor error
			//If there is an error when saving comment we want to render the Comment Box(Editor)
			//and the corresponding warning message

			//Hide Add comment Box when User is Replying to or Editing a comment
			//For anonymous users displayName is not passed
			//reset any Editor errors that present in editorState
			injectIntl(
				withAnalyticsEvents()(
					class CommentsSectionFabricComponent extends Component {
						static propTypes = {
							accountId: PropTypes.string,
							intl: PropTypes.object,
							replace: PropTypes.func.isRequired,
							location: PropTypes.object,
							contentId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
							isAutoScrollingEnabled: PropTypes.bool,
							enableScrolling: PropTypes.func,
							totalComments: PropTypes.number,
							isRequesting: PropTypes.bool,
							spaceId: PropTypes.string,
							commentsData: PropTypes.arrayOf(
								PropTypes.shape({
									ancestors: PropTypes.array.isRequired,
									depthLevel: PropTypes.number.isRequired,
									parentId: PropTypes.string,
									version: PropTypes.shape({
										id: PropTypes.string.isRequired,
										by: PropTypes.object.isRequired,
										when: PropTypes.string.isRequired,
										number: PropTypes.number.isRequired,
									}),
									createdBy: PropTypes.shape({
										isAnonymous: PropTypes.bool.isRequired,
										displayName: PropTypes.string,
										avatarUrl: PropTypes.string.isRequired,
										permissionType: PropTypes.string.isRequired,
									}),
									createdByAuthor: PropTypes.bool.isRequired,
									id: PropTypes.string.isRequired,
									linkWebui: PropTypes.string.isRequired,
									operations: PropTypes.array,
									permissions: PropTypes.object,
									createdFriendly: PropTypes.string.isRequired,
									contentStatus: PropTypes.string.isRequired,
									isFromMobile: PropTypes.bool.isRequired,
								}),
							).isRequired,
							focusOnCommentId: PropTypes.string,
							replyToCommentId: PropTypes.string,
							contentType: PropTypes.oneOf(['blogpost', 'page']),
							contentSubType: PropTypes.string,
							atlToken: PropTypes.string,
							currentUserInfo: PropTypes.object,
							deleteComment: PropTypes.func,
							saveComment: PropTypes.func,
							shouldOpenAddComment: PropTypes.bool,
							openEditCommentId: PropTypes.string,
							isEditCommentFound: PropTypes.bool,
							canAddComments: PropTypes.bool.isRequired,
							onRefetchComments: PropTypes.func,
							commentsIds: PropTypes.array,
							hasNextPage: PropTypes.bool,
							hasFetchedComments: PropTypes.bool,
							deleteCommentError: PropTypes.object,
							editedCommentsIds: PropTypes.array,
							createAnalyticsEvent: PropTypes.func.isRequired,
							isEditCommentAllowed: PropTypes.bool,
							experienceTracker: PropTypes.object.isRequired,
							searchSessionState: PropTypes.shape({
								searchSessionId: PropTypes.string,
							}),
							handlePageCommentsRender: PropTypes.func,
							isPageCommentsSortingExperimentEnabled: PropTypes.bool.isRequired,
							pageCommentsSortingExperimentCohort: PropTypes.oneOf([
								'control',
								'experimentOldestButtonTop',
								'experimentNewestButtonTop',
							]),
							setCreatedComment: PropTypes.func,
							isWebToMobileQrPromoEnabled: PropTypes.bool,
							sessionData: PropTypes.object,
							inlineCommentsCount: PropTypes.number,
						};

						static getDerivedStateFromProps(nextProps, prevState) {
							if (
								!isEqual(prevState.commentsIds, nextProps.commentsIds) &&
								prevState.hasNextPage === false &&
								nextProps.hasNextPage === false &&
								nextProps.hasFetchedComments
							) {
								return {
									commentsIds: nextProps.commentsIds,
									hasNextPage: nextProps.hasNextPage,
									updatedCommentsIds: _difference(nextProps.commentsIds, prevState.commentsIds),
								};
							} else {
								return {
									...prevState,
									commentsIds: nextProps.commentsIds,
									hasNextPage: nextProps.hasNextPage,
								};
							}
						}

						state = {
							commentsIds: this.props.commentsIds,
							autoFocusedCommentId: '',
							updatedCommentsIds: [],
							hasNextPage: this.props.hasNextPage,
							editorState: {
								commentId: null,
								mode: EDITOR_MODE.RESET,
								formattedErrorMessage: {},
								errorType: null,
								isEditorLoaded: false,
								errorDetails: '',
								hasContentChanged: false,
							},
							allCommentsLoaded: false,
							commentsSortable: false,
							isSorted: false,
							sortedComments: this.props.commentsData || [],
							isPermissionsError: false,
							isFooterCommentsSummaryEnabled: false,
							isFooterCommentsSummaryOpen: false,
							isSummaryAutogenerated: false,
							shouldRefetchCommentsSummary: false,
							hasSummaryButtonBeenSeen: false,
						};

						componentDidMount() {
							const {
								shouldOpenAddComment,
								canAddComments,
								totalComments,
								hasFetchedComments,
								handlePageCommentsRender,
								inlineCommentsCount,
								sessionData,
							} = this.props;

							const footerCommentsSummaryCombinedExperimentValue = FeatureGates.getExperimentValue(
								'cc_smarts_inline_comments_summary',
								'comments_summary_position',
								'control',
							);
							const footerCommentsSummaryEnabled =
								sessionData?.isAdminHubAIEnabled &&
								footerCommentsSummaryCombinedExperimentValue === 'footer';

							const commentSummaryAutogenThreshold = FeatureGates.getExperimentValue(
								'cc_smarts_commment_summary_autogen_threshold',
								'autogen_threshold',
								SUMMARY_AUTOGENERATE_LIMIT,
							);

							if (totalComments === 0) {
								/* Pass callback to ViewPageFooterComments indicating Add comment Box has rendered to
          toggle CommentPlaceholder display*/
								handlePageCommentsRender && handlePageCommentsRender();
							} else if (
								(totalComments >= commentSummaryAutogenThreshold ||
									inlineCommentsCount >= commentSummaryAutogenThreshold) &&
								footerCommentsSummaryEnabled
							) {
								this.setState({
									isFooterCommentsSummaryOpen: true,
									isSummaryAutogenerated: true,
								});
							}

							if (
								hasFetchedComments &&
								shouldOpenAddComment &&
								canAddComments &&
								totalComments === 0
							) {
								this._triggerShowAddCommentEditor();
							}

							if (footerCommentsSummaryEnabled) {
								this.setState({ isFooterCommentsSummaryEnabled: true });
							}
						}

						componentDidUpdate(prevProps, prevState) {
							rebindUserHover();

							const {
								focusOnCommentId,
								replyToCommentId,
								openEditCommentId,
								isEditCommentFound,
								isEditCommentAllowed,
								canAddComments,
								shouldOpenAddComment,
								commentsIds,
								commentsData,
								isAutoScrollingEnabled,
								isPageCommentsSortingExperimentEnabled,
								totalComments,
								inlineCommentsCount,
							} = this.props;

							const {
								allCommentsLoaded,
								editorState,
								commentsSortable,
								isSorted,
								isFooterCommentsSummaryEnabled,
								isFooterCommentsSummaryOpen,
								shouldRefetchCommentsSummary,
							} = this.state;

							if (
								isPageCommentsSortingExperimentEnabled &&
								(isSorted !== prevState.isSorted ||
									commentsData.length !== prevProps.commentsData.length ||
									commentsSortable !== prevState.commentsSortable)
							) {
								this._sortComments();
							}
							const shouldScrollToComment =
								allCommentsLoaded && prevState.allCommentsLoaded === false;

							/* foucusedComment can be from external Link or comment notification*/
							const shouldFocusComment =
								shouldScrollToComment ||
								(commentsIds.length !== prevProps.commentsIds.length &&
									commentsIds.some((id) => id === focusOnCommentId));

							/* Only focus, Reply ,Edit comments or Open Comment Editor once all Page Comments are loaded*/

							if (shouldFocusComment && focusOnCommentId && isAutoScrollingEnabled) {
								this.scrollToElement(`comment-${focusOnCommentId}`);
							}

							if (
								shouldScrollToComment &&
								replyToCommentId &&
								editorState.commentId !== replyToCommentId &&
								canAddComments
							) {
								this._replyCommentAction(replyToCommentId);
							}

							if (shouldScrollToComment && openEditCommentId && isEditCommentFound) {
								this.scrollToElement(`comment-${openEditCommentId}`);
								if (isEditCommentAllowed) {
									this._editCommentAction(openEditCommentId);
								}
							}

							if (shouldScrollToComment && shouldOpenAddComment && canAddComments) {
								this._triggerShowAddCommentEditor();
							}

							if (shouldScrollToComment && shouldOpenAddComment) {
								this.scrollToElement('addcomment');
							}

							if (
								isFooterCommentsSummaryEnabled &&
								!shouldRefetchCommentsSummary &&
								(totalComments !== prevProps.totalComments ||
									inlineCommentsCount !== prevProps.inlineCommentsCount)
							) {
								this.setState({ shouldRefetchCommentsSummary: true });
							}

							if (
								shouldRefetchCommentsSummary &&
								isFooterCommentsSummaryOpen &&
								prevState.isFooterCommentsSummaryOpen !== isFooterCommentsSummaryOpen
							) {
								this.setState({ shouldRefetchCommentsSummary: false });
							}
						}

						componentWillUnmount() {
							this._hideEditor();
						}

						loadedCommentsCount = 0;
						commentsBatchRendered = false;
						createCommentTimestampStart = -1;
						createCommentTimestampEnd = -1;

						scrollToElement(id) {
							const element = getElementById(id);
							if (element && this.scrollElementIntoView) {
								this.scrollElementIntoView(element);
							}
						}

						_showEditor = (newProps) => {
							const prevEditorState = this.state.editorState;

							this.setState({
								editorState: {
									...prevEditorState,
									...newProps,
									...NO_EDITOR_ERROR_STATE,
								},
							});
						};

						_setAutoFocusedCommentId = (id) => {
							this.setState({ autoFocusedCommentId: id });
						};

						_resetAutoFocusedCommentId = () => {
							this.setState({ autoFocusedCommentId: '' });
						};

						_hideEditor = () => {
							const prevEditorState = this.state.editorState;
							const noEditor = {
								commentId: null,
								mode: EDITOR_MODE.RESET,
								isEditorLoaded: false,
								...NO_EDITOR_ERROR_STATE,
							};

							this.setState({
								editorState: {
									...prevEditorState,
									...noEditor,
								},
							});
						};

						_onEditorLoaded = () => {
							const prevEditorState = this.state.editorState;

							this.setState({
								editorState: {
									...prevEditorState,
									isEditorLoaded: true,
								},
							});
						};

						_getThreadLastCommentId(commentId) {
							const { commentsData } = this.props;

							let lastThreadCommentId;
							let currentCommentDepthLevel;
							let previouslyCheckedCommentId;
							let previouslyCheckedCommentIdInBranch;

							commentsData.forEach((el) => {
								if (!lastThreadCommentId) {
									if (typeof currentCommentDepthLevel !== 'undefined') {
										if (currentCommentDepthLevel >= el.depthLevel) {
											lastThreadCommentId = previouslyCheckedCommentId;
										} else {
											previouslyCheckedCommentIdInBranch = el.id;
										}
									}

									if (el.id === commentId) {
										currentCommentDepthLevel = el.depthLevel;
									}
									previouslyCheckedCommentId = el.id;
								}
							});

							if (!lastThreadCommentId) {
								lastThreadCommentId = previouslyCheckedCommentIdInBranch || commentId;
							}

							return lastThreadCommentId;
						}

						_replyCommentAction = (commentId) => {
							this._showEditor({
								commentId,
								mode: EDITOR_MODE.REPLY,
							});
						};

						_editCommentAction = (commentId) => {
							this._showEditor({ mode: EDITOR_MODE.EDIT, commentId });
						};

						_showAddCommentEditor = (event) => {
							if (event) {
								event.preventDefault();
							}
							this._warnCommentLost(() => {
								this._showEditor({
									mode: EDITOR_MODE.ADD,
									commentId: NEW_COMMENT_ID,
								});
							});
						};

						_triggerShowAddCommentEditor = (event) => {
							setTimeout(() => this.scrollToElement('addcomment'), 0);
							this._showAddCommentEditor(event);
						};

						_warnCommentLost = (func) => {
							const { formatMessage } = this.props.intl;
							const isEditorOpen = this.state.editorState && this.state.editorState.isEditorLoaded;
							const { hasContentChanged } = this.state.editorState;

							if (
								!isEditorOpen ||
								!hasContentChanged ||
								confirm(formatMessage({ id: 'unsaved.comment.lost' }))
							) {
								func();
							}
						};

						_callAnalyticsEvent = (analyticsObj) => {
							this.props.createAnalyticsEvent(analyticsObj).fire();
						};

						_getCommentAnalyticsObject = (params) => {
							const { id, spaceId, ownerId, requestType, contentType, contentSubType, parentId } =
								params;
							const {
								searchSessionState: { searchSessionId },
							} = this.props;

							return {
								containerType: 'space',
								containerId: spaceId,
								source: 'viewPageScreen',
								objectType: 'page',
								objectId: ownerId.toString(),
								action: requestType === 'editComment' ? 'updated' : 'created',
								actionSubject: 'comment',
								actionSubjectId: id,
								attributes: {
									commentType: 'page',
									pageType: contentType,
									isLivePage: contentSubType === 'live',
									parentCommentId: parentId ? parentId.toString() : null, // analytics event schema expects string | null
									editor: 'v2',
									searchSessionId,
									navdexPointType: END,
								},
							};
						};

						handleSuccess = (data) => {
							const {
								onRefetchComments,
								contentId,
								spaceId,
								contentType,
								contentSubType,
								experienceTracker,
							} = this.props;
							const { editorState } = this.state;

							const {
								data: {
									experimentalSaveFabricComment: { id, ancestors, container },
								},
							} = data;

							const parentId = (ancestors[0] && ancestors[0].id) || 0;

							const ownerId = container && container.id;

							const commentAnalyticsObject = this._getCommentAnalyticsObject({
								id,
								spaceId,
								parentId,
								contentType,
								contentSubType,
								ownerId,
								requestType: editorState.mode,
							});

							this._callAnalyticsEvent({
								data: commentAnalyticsObject,
								type: 'sendTrackEvent',
							});

							const refetchOptions = {
								commentId: id,
								threadLastCommentId: this._getThreadLastCommentId(editorState.commentId),
								parentId,
								mode: editorState.mode,
							};

							// end timestamp
							this.createCommentTimestampEnd = Date.now();

							this._callAnalyticsEvent({
								type: 'sendTrackEvent',
								data: {
									source: 'viewPage',
									action: 'called',
									actionSubject: 'api',
									actionSubjectId: 'createPageComment',
									attributes: {
										contentId,
										duration: this.createCommentTimestampEnd - this.createCommentTimestampStart,
									},
								},
							});

							experienceTracker.succeed({
								name: ADD_PAGE_COMMENT_EXPERIENCE,
							});

							onRefetchComments(refetchOptions).then(() => {
								this._hideEditor();
								this._setAutoFocusedCommentId(id);
							});

							if (this.props.isWebToMobileQrPromoEnabled) {
								this.props.setCreatedComment();
							}
						};

						handleError = async (error, version) => {
							const { canAddComments, contentId } = this.props;
							const {
								editorState: { mode, commentId },
							} = this.state;

							let errorType, formattedErrorMessage;

							try {
								({ errorType, formattedErrorMessage } = await processAndFetchErrorDetails({
									error,
									canAddComments,
									callAnalyticsEvent: this._callAnalyticsEvent,
									contentId,
									mode,
									commentId,
									version,
								}));
							} catch (err) {
								logger.error`An error occurred while processing Comment Errors - ${err}`;
							}

							if (errorType === ERROR_TYPES.KNOWN_ERROR) {
								this._abortExperience(error);
								if (formattedErrorMessage === i18n.permissionsError) {
									this.setState({ isPermissionsError: true });
								}
							}

							const newEditorState = {
								errorType: errorType || ERROR_TYPES.UNHANDLED_ERROR,
								formattedErrorMessage: formattedErrorMessage || i18n.genericError,
								errorDetails: error,
							};

							const prevEditorState = this.state.editorState;

							this.setState({
								editorState: {
									...prevEditorState,
									...newEditorState,
								},
							});

							return Promise.reject({ skipErrorHandling: true });
						};

						_editorSaveHandler = (props) => {
							const { saveComment, experienceTracker, sessionData } = this.props;
							const { editorState } = this.state;

							if (isEmptyAdf(props.adf)) {
								const newEditorState = {
									formattedErrorMessage: i18n.emptyComment,
									errorType: ERROR_TYPES.KNOWN_ERROR,
								};

								const prevEditorState = this.state.editorState;

								this.setState({
									editorState: {
										...prevEditorState,
										...newEditorState,
									},
								});

								return Promise.reject();
							}
							const { mode } = editorState;
							props.requestType = mode;

							if (mode === EDITOR_MODE.REPLY) {
								props.showCommentAfter = this._getThreadLastCommentId(editorState.commentId);
							}

							if (mode !== EDITOR_MODE.RESET) {
								// start timestamp
								this.createCommentTimestampStart = Date.now();
								experienceTracker.start({
									name: ADD_PAGE_COMMENT_EXPERIENCE,
									timeout: ExperienceTimeout.EDITOR_PUBLISH,
									attributes: {
										editor: EDITOR_VERSIONS.FABRIC,
										mode,
										isSingleExperience: true,
										edition: sessionData?.edition,
									},
								});
							}

							return saveComment(props)
								.then(this.handleSuccess)
								.catch((error) => {
									const { version } = props;
									return this.handleError(error, version);
								})
								.finally(this._removeSlowCommentURLParams);
						};

						_editorCancelHandler = ({ isEditorAborted }) => {
							const { experienceTracker } = this.props;
							this._hideEditor();
							if (isEditorAborted) {
								this._removeSlowCommentURLParams();

								experienceTracker.abort({
									name: ADD_PAGE_COMMENT_EXPERIENCE,
									reason: 'CommentsSectionFabricComponent _editorCancelHandler',
								});
							}
						};

						_removeSlowCommentURLParams = () => {
							const { replace, location } = this.props;
							const query = location.query;
							const paramsToRemove = [
								'showCommentArea',
								'showComments',
								'editComment',
								'commentId',
							];

							const shouldCleanup = paramsToRemove
								.map((key) => typeof query[key] !== 'undefined')
								.filter((res) => res).length;

							if (!shouldCleanup) {
								return;
							}
							const newQuery = omit(location.query, paramsToRemove);

							replace({
								...location,
								query: newQuery,
								search: format({ query: newQuery }),
							});
						};

						_canViewProfile() {
							const { isAnonymous, currentUserCanViewProfile } = this.props.currentUserInfo;
							return !isAnonymous
								? currentUserCanViewProfile !== false
								: currentUserCanViewProfile === true;
						}

						_onDeleteComment = (commentId) => this.props.deleteComment(commentId);

						_onReplyToComment = (commentId) => {
							this._warnCommentLost(() => this._replyCommentAction(commentId));
						};

						_onEditComment = (commentId) => {
							this._warnCommentLost(() => this._editCommentAction(commentId));
						};

						_onEditorContentChanged = (hasContentChanged) => {
							this.setState((prev) => ({
								...prev,
								editorState: {
									...prev.editorState,
									hasContentChanged,
								},
							}));
						};

						_getCommentActions = () => ({
							deleteComment: this._onDeleteComment,
							replyToComment: this._onReplyToComment,
							editComment: this._onEditComment,
						});

						_isAddCommentEditorEnabled() {
							const { editorState } = this.state;
							return (
								editorState.commentId === NEW_COMMENT_ID && editorState.mode === EDITOR_MODE.ADD
							);
						}

						_checkForParentComments = () => {
							const { commentsData } = this.props;

							const parentListToBeSorted = [];
							const parentCommentToReplies = {};
							let parentComment = '';

							commentsData.forEach((comment) => {
								if (comment?.depthLevel === 0) {
									parentComment = comment.version.id;
									parentCommentToReplies[parentComment] = [];
									parentListToBeSorted.push(comment);
								} else if (
									parentCommentToReplies &&
									parentComment &&
									parentCommentToReplies[parentComment]
								) {
									//TODO: Need to revisit fix this logic. This line of code makes an assumption that all child comment can push to an exsiting parentComment array
									//But in JST-809125 data returns a comment with parentId but such parent comment is not in result set, cause an orphaned child comment
									parentCommentToReplies[parentComment].push(comment);
								}
							});
							return [parentListToBeSorted, parentCommentToReplies];
						};

						_sortComments = () => {
							const { isSorted } = this.state;
							const { commentsData } = this.props;

							if (!isSorted) {
								this.setState({ sortedComments: commentsData });
							} else {
								const [parentListToBeSorted, parentCommentToReplies] =
									this._checkForParentComments();

								parentListToBeSorted.sort((a, b) => {
									const comment1 = Date.parse(Date(b?.version?.when));
									const comment2 = Date.parse(Date(a?.version?.when));

									comment1 - comment2;
								});

								parentListToBeSorted.reverse();
								const sortedComments = [];
								parentListToBeSorted.forEach((comment) => {
									sortedComments.push(comment);
									sortedComments.push(...parentCommentToReplies[comment.version.id]);
								});
								this.setState({ sortedComments });
							}
						};

						_sendSortAnalytics = (sortBy) => {
							this.props
								.createAnalyticsEvent({
									type: 'sendUIEvent',
									data: {
										source: 'viewPage',
										action: 'clicked',
										actionSubject: 'button',
										actionSubjectId: 'pageCommentSortBy',
										attributes: {
											sortBy,
										},
									},
								})
								.fire();
						};

						_handleSortNew = () => {
							this.setState({ isSorted: true });
							this._sendSortAnalytics('newest');
						};

						_handleSortOld = () => {
							this.setState({ isSorted: false });
							this._sendSortAnalytics('oldest');
						};

						_handleFooterCommentsSummaryButtonClick = () => {
							this.setState((prevState) => ({
								isFooterCommentsSummaryOpen: !prevState.isFooterCommentsSummaryOpen,
								isSummaryAutogenerated: false,
							}));
						};

						_handleFooterCommentsSummaryRefresh = () => {
							const { shouldRefetchCommentsSummary } = this.state;

							if (shouldRefetchCommentsSummary) {
								this.setState({ shouldRefetchCommentsSummary: false });
							}
						};

						_handleSummaryButtonSeen = () => {
							const { hasSummaryButtonBeenSeen } = this.state;

							if (!hasSummaryButtonBeenSeen) {
								this.setState({ hasSummaryButtonBeenSeen: true });
							}
						};

						_renderSortByOldestButton() {
							return (
								<DropdownItem data-testid="sort-by-oldest" onClick={this._handleSortOld}>
									<FormattedMessage {...i18n.pageCommentSortOldest} />
								</DropdownItem>
							);
						}

						_renderSortByNewestButton() {
							return (
								<DropdownItem data-testid="sort-by-newest" onClick={this._handleSortNew}>
									<FormattedMessage {...i18n.pageCommentSortNewest} />
								</DropdownItem>
							);
						}

						_renderSortByDropdown() {
							const { pageCommentsSortingExperimentCohort } = this.props;
							if (pageCommentsSortingExperimentCohort === 'experimentOldestButtonTop') {
								return (
									<>
										{this._renderSortByOldestButton()}
										{this._renderSortByNewestButton()}
									</>
								);
							} else if (pageCommentsSortingExperimentCohort === 'experimentNewestButtonTop') {
								return (
									<>
										{this._renderSortByNewestButton()}
										{this._renderSortByOldestButton()}
									</>
								);
							}
						}

						_renderHeadLine() {
							const {
								contentId,
								totalComments,
								isPageCommentsSortingExperimentEnabled,
								inlineCommentsCount,
							} = this.props;
							const {
								isSorted,
								isFooterCommentsSummaryEnabled,
								isFooterCommentsSummaryOpen,
								allCommentsLoaded,
							} = this.state;
							const parentListToBeSorted = isPageCommentsSortingExperimentEnabled
								? this._checkForParentComments()
								: [];

							const sortMessage = isSorted
								? i18n.pageCommentSortNewest
								: i18n.pageCommentSortOldest;

							const inlineCommentCountThresholdMet =
								inlineCommentsCount >= SUMMARY_VISIBILITY_THRESHOLD;
							const pageCommentCountThresholdMet = totalComments >= SUMMARY_VISIBILITY_THRESHOLD;
							const commentCountThresholdMet =
								inlineCommentCountThresholdMet || pageCommentCountThresholdMet;

							if (
								isFooterCommentsSummaryEnabled &&
								!totalComments &&
								inlineCommentCountThresholdMet
							) {
								return (
									<CommentHeadline>
										<Inline space="space.150" alignBlock="center">
											<FooterCommentsSummaryButton
												contentId={contentId}
												isFooterCommentsSummaryOpen={isFooterCommentsSummaryOpen}
												onClick={this._handleFooterCommentsSummaryButtonClick}
												onSeen={this._handleSummaryButtonSeen}
											/>
										</Inline>
									</CommentHeadline>
								);
							}

							return !totalComments ? null : (
								<CommentHeadline>
									<Inline space="space.150" alignBlock="center">
										<h2 data-testid="comments-count">
											<CommentIcon label="comment count icon" />
											{totalComments === 1 ? (
												<FormattedMessage {...i18n.pageCommentSingular} />
											) : (
												<FormattedMessage {...i18n.pageCommentPlural} values={{ totalComments }} />
											)}
										</h2>
										{isFooterCommentsSummaryEnabled && commentCountThresholdMet && (
											<FooterCommentsSummaryButton
												contentId={contentId}
												isFooterCommentsSummaryOpen={isFooterCommentsSummaryOpen}
												onClick={this._handleFooterCommentsSummaryButtonClick}
												onSeen={this._handleSummaryButtonSeen}
											/>
										)}
									</Inline>
									{parentListToBeSorted.length > 1 && allCommentsLoaded && (
										<FormattedMessage {...sortMessage}>
											{(text) => (
												<DropdownMenu
													testId="sort-comments-menu"
													placement="bottom-end"
													trigger={text}
												>
													<DropdownItemGroup>{this._renderSortByDropdown()}</DropdownItemGroup>
												</DropdownMenu>
											)}
										</FormattedMessage>
									)}
								</CommentHeadline>
							);
						}

						_renderEditCommentErrorFlag() {
							const { openEditCommentId, isEditCommentFound, isEditCommentAllowed } = this.props;
							return openEditCommentId && !isEditCommentFound ? (
								<SectionMessage appearance="warning">
									<FormattedMessage {...i18n.editCommentNotFound} />
								</SectionMessage>
							) : isEditCommentFound && !isEditCommentAllowed ? (
								<SectionMessage appearance="warning">
									<FormattedMessage {...i18n.permissionsError} />
								</SectionMessage>
							) : null;
						}

						_renderAddCommentErrorFlag() {
							const { canAddComments, replyToCommentId, shouldOpenAddComment } = this.props;
							const isAddCommentNotAllowed =
								(replyToCommentId || shouldOpenAddComment) && !canAddComments;
							return isAddCommentNotAllowed || this.state.isPermissionsError ? (
								<SectionMessage appearance="warning">
									<FormattedMessage {...i18n.permissionsError} />
								</SectionMessage>
							) : null;
						}

						onCommentRendered = () => {
							const {
								totalComments,
								handlePageCommentsRender,
								isAutoScrollingEnabled,
								enableScrolling,
							} = this.props;
							if (!isAutoScrollingEnabled) {
								enableScrolling();
							}

							if (this.loadedCommentsCount === totalComments) {
								return;
							}

							this.loadedCommentsCount = this.loadedCommentsCount + 1;

							/* Mark first X Number of comments Rendered
        Total Comments < 10 - Mark when first x comments Render
        Total Comments >= 10 - Mark when first 10 comments Render
      */
							if (
								!this.commentsBatchRendered &&
								((totalComments < BATCH_SIZE && this.loadedCommentsCount === totalComments) ||
									this.loadedCommentsCount === BATCH_SIZE)
							) {
								this.commentsBatchRendered = true;
								PAGE_COMMENTS_METRIC.mark('pageCommentsRenderEnd');
								/* Pass callback to ViewPageFooterComments indicating first X comments have rendered to
          toggle CommentPlaceholder display*/
								handlePageCommentsRender && handlePageCommentsRender();
							}

							/* All comments Rendered*/
							if (this.loadedCommentsCount === totalComments) {
								this.setState({ allCommentsLoaded: true });
							}
						};

						_renderCommentsList() {
							const {
								contentId,
								currentUserInfo,
								contentType,
								contentSubType,
								focusOnCommentId,
								editedCommentsIds,
								atlToken,
								spaceId,
								canAddComments,
								experienceTracker,
								commentsData,
								isPageCommentsSortingExperimentEnabled,
							} = this.props;

							const { updatedCommentsIds, commentsIds, editorState, sortedComments } = this.state;

							const props = {
								atlToken,
								commentsIds,
								contentType,
								contentSubType,
								contentId,
								comments: isPageCommentsSortingExperimentEnabled ? sortedComments : commentsData,
								commentActions: this._getCommentActions(),
								showAuthorLabel: contentType === 'blogpost',
								focusOnCommentId,
								highlightedComments:
									editedCommentsIds.length > 0 ? editedCommentsIds : updatedCommentsIds,
								userInfo: currentUserInfo,
								editor: editorState,
								canViewProfile: this._canViewProfile(),
								editorSaveHandler: this._editorSaveHandler,
								editorCancelHandler: this._editorCancelHandler,
								onEditorLoaded: this._onEditorLoaded,
								onEditorContentChanged: this._onEditorContentChanged,
								spaceId,
								canReplyToComment: canAddComments,
								autoFocusedCommentId: this.state.autoFocusedCommentId,
								onCommentAutoFocused: this._resetAutoFocusedCommentId,
								experienceTracker,
								onRendered: this.onCommentRendered,
							};

							return <CommentsListBatch key={`commentList${contentId}`} {...props} />;
						}

						_renderAddCommentField() {
							const {
								contentId,
								canAddComments,
								currentUserInfo,
								atlToken,
								contentType,
								contentSubType,
								spaceId,
								experienceTracker,
								totalComments,
							} = this.props;

							const { editorState } = this.state;

							if (!canAddComments && !editorState.errorType) {
								return null;
							}

							const isReplyOrEdit =
								editorState.mode === EDITOR_MODE.REPLY || editorState.mode === EDITOR_MODE.EDIT;

							if (isReplyOrEdit) {
								return null;
							}

							const props = {
								contentId,
								atlToken,
								mode: 'add',
								userInfo: currentUserInfo,
								isEditorEnabled: this._isAddCommentEditorEnabled(),
								onClickCommentAddPrompt: this._showAddCommentEditor,
								editor: editorState,
								canViewProfile: this._canViewProfile(),
								editorSaveHandler: this._editorSaveHandler,
								editorCancelHandler: this._editorCancelHandler,
								onEditorContentChanged: this._onEditorContentChanged,
								onEditorLoaded: this._onEditorLoaded,
								contentType,
								contentSubType,
								spaceId,
								experienceTracker,
								totalComments,
							};

							return <Comment {...props} />;
						}

						_closeEditorError = () => {
							const noError = { errorType: '', formattedErrorMessage: {} };
							const prevEditorState = this.state.editorState;
							this.setState({
								editorState: {
									...prevEditorState,
									...noError,
								},
							});
						};

						_abortExperience = (error) => {
							const { experienceTracker } = this.props;
							experienceTracker.abort({
								name: ADD_PAGE_COMMENT_EXPERIENCE,
								reason: `A warning is displayed to User on how to recover for the error -  ${error}`,
							});
						};

						_renderErrorFlag(flags) {
							const { editorState } = this.state;
							const { experienceTracker } = this.props;
							experienceTracker.stopOnError({
								name: ADD_PAGE_COMMENT_EXPERIENCE,
								error: editorState.errorDetails,
							});
							return (
								<CommentErrorFlag
									flags={flags}
									errorTitle={i18n.errorTitle}
									errorMessage={i18n.genericError}
									onCloseFlag={this._closeEditorError}
									errorDetails={i18n.errorDetails}
								/>
							);
						}

						_renderDeleteCommentErrorMessage(flags) {
							return (
								<CommentErrorFlag
									flags={flags}
									errorTitle={i18n.deleteErrorTitle}
									errorMessage={i18n.genericError}
									onCloseFlag={this._closeEditorError}
									errorDetails={i18n.errorDetails}
								/>
							);
						}

						_openCommentEditor = (event) => {
							event.stopPropagation();
							this._triggerShowAddCommentEditor();
							this._callAnalyticsEvent({
								data: {
									source: 'viewPage',
									action: 'pressed',
									actionSubject: 'keyboardShortcut',
									actionSubjectId: 'createComment',
									attributes: {
										key: 'm',
									},
								},
								type: 'sendUIEvent',
							});
						};

						render() {
							const {
								deleteCommentError,
								totalComments,
								hasFetchedComments,
								hasNextPage,
								contentId,
								contentType,
								spaceId,
							} = this.props;

							const {
								editorState,
								allCommentsLoaded,
								isFooterCommentsSummaryEnabled,
								isFooterCommentsSummaryOpen,
								shouldRefetchCommentsSummary,
								isSummaryAutogenerated,
								hasSummaryButtonBeenSeen,
							} = this.state;
							const shouldShowCommentsSummary =
								isFooterCommentsSummaryEnabled && isFooterCommentsSummaryOpen;

							return (
								<Subscribe to={[FlagsStateContainer]}>
									{(flags) => (
										<CommentsSectionContainer
											id="comments-section-fabric"
											data-testid="comments-section-fabric-new"
											data-vc="comments-section-fabric"
										>
											{this._renderHeadLine()}
											{hasSummaryButtonBeenSeen && shouldShowCommentsSummary && (
												<Box paddingBlock="space.150">
													<FooterCommentsSummaryCombined
														contentId={contentId}
														contentType={contentType}
														isSummaryAutogenerated={isSummaryAutogenerated}
														shouldRefetchCommentsSummary={shouldRefetchCommentsSummary}
														onRefresh={this._handleFooterCommentsSummaryRefresh}
														source={CommentsSummarySource.Footer}
														spaceKey={spaceId}
													/>
												</Box>
											)}
											{this._renderEditCommentErrorFlag()}
											{this._renderAddCommentErrorFlag()}
											{deleteCommentError ? this._renderDeleteCommentErrorMessage(flags) : null}
											{this._renderCommentsList()}
											{this._renderAddCommentField()}
											{editorState.errorType === ERROR_TYPES.UNHANDLED_ERROR
												? this._renderErrorFlag(flags)
												: null}
											{!hasNextPage ? (
												<Fragment>
													{totalComments > 0 ? (
														<ExperienceSuccess
															name={VIEW_PAGE_COMMENTS_EXPERIENCE}
															attributes={{ totalComments }}
														/>
													) : (
														<ExperienceAbort
															name={VIEW_PAGE_COMMENTS_EXPERIENCE}
															reason="No page comments"
														/>
													)}
													{hasFetchedComments && this.commentsBatchRendered && (
														<Fragment>
															<PageSegmentLoadMark markName="fmp" metric={PAGE_COMMENTS_METRIC} />
															<PageSegmentLoadMark markName="tti" metric={PAGE_COMMENTS_METRIC} />
														</Fragment>
													)}
													{hasFetchedComments && (allCommentsLoaded || totalComments === 0) ? (
														<PageSegmentLoadEnd
															key={contentId}
															metric={PAGE_COMMENTS_METRIC}
															customData={{ isNext: false, totalComments }}
														/>
													) : null}
												</Fragment>
											) : null}
											<DocumentScroller>
												{({ scrollToElement }) => {
													this.scrollElementIntoView = scrollToElement;
													return null;
												}}
											</DocumentScroller>
											<GeneralShortcutListener
												accelerator={CREATE_COMMENT_SHORTCUT}
												listener={this._openCommentEditor}
											/>
										</CommentsSectionContainer>
									)}
								</Subscribe>
							);
						}
					},
				),
			),
		),
	),
);
